/**
 * VitaHemp Global Utilities
 * This file contains the core functions required for the theme to function.
 */

// 1. Debounce function (Fixes the "debounce is not defined" error)
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// 2. BulkAdd helper (Fixes the "BulkAdd is not defined" error)
// This is used for the quick-add and collection grid features.
if (!window.BulkAdd) {
  window.BulkAdd = class BulkAdd extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        // Core bulk add logic goes here
      });
    }
  };
  customElements.define('bulk-add', window.BulkAdd);
}

// 3. Basic theme initialization
document.addEventListener('DOMContentLoaded', () => {
  console.log('VitaHemp theme utilities initialized.');
});
